/* eslint-disable max-len */
/* eslint-disable no-console */
import { API } from 'aws-amplify';
import {
	UPDATE_UPLOAD_SETTINGS,
	UpdateUploadSettingsPayload,
	UploadSettings
} from './types';

// API endpoint name as configured in index.tsx
const API_NAME = 'revisedResources';

/**
 * Update the upload settings
 * @param companyId - Company identifier
 * @param payload - Object containing the updated upload settings
 * @returns The updated upload settings configuration
 */
export const updateUploadSettings = async (
  companyId: string, 
  payload: UpdateUploadSettingsPayload
): Promise<{ uploadSettings: Partial<UploadSettings> }> => {
  try {
    const response = await API.patch(
      API_NAME,
      `/configurations/${companyId}/upload-settings`,
      {
        body: payload
      }
    );
    
    // Return the updated configuration
    if (response?.data?.uploadSettings) {
      return {
        uploadSettings: response.data.uploadSettings
      };
    }
    
    // If no uploadSettings in response, return what we sent
    // This handles edge cases where the API doesn't return the updated data
    const defaultSettings: Partial<UploadSettings> = {};
    
    if (payload.sources) {
      defaultSettings.sources = {
        local: true,
        mediaDrive: true,
        embeddedLink: true,
        resources: true,
        ...payload.sources
      };
    }
    
    if (payload.maxFileSizeMB !== undefined) {
      defaultSettings.maxFileSizeMB = payload.maxFileSizeMB;
    }
    
    return {
      uploadSettings: defaultSettings
    };
  } catch (error) {
    console.error('Error updating upload settings:', error);
    throw error;
  }
}; 